import React, { useState, useEffect } from 'react';

import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';
import { Alert, Dropdown, OverlayTrigger, Table } from 'react-bootstrap';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { CustomButton, Loading, Error } from '../../_common';
import {
    GET_JOB_LOG_META_DATA,
    GET_STAGES,
    GET_STAGE_DETAILS,
    GET_STAGE_SUMMARY,
    GET_WELL_HEADS_BY_JOB_ID,
    GET_WELL_HEADS_BY_STAGE_GROUP_ID,
} from '../../../graphql/client/queries';
import {
    GetStageSummary,
    GetStageSummary_getStageSummary as StageSummary,
    GetStageDetails,
    GetStageDetails_getStageDetails_stageDetails as StageDetails,
    GetWellheadsByJobId,
    GetWellheadsByJobId_getWellheadsByJobId as Wellheads,
    GetWellheadsByStageGroupId,
    GetJobLogMetaData,
    GetJobLogMetaData_getJobLogMetaData_types as JobLogTypesType,
    GetJobLogMetaData_getJobLogMetaData_issues as JobLogIssueType,
    GetJobLogMetaData_getJobLogMetaData_rootcauses as JobLogRootCauseType,
    GetJobLogMetaData_getJobLogMetaData_locationLOFAs as JobLogLocationLofaType,
    GetStages_getStages as StageNumberType,
    AddStages,
    StageDetailsForAddStages,
    StageDetailsForEditStages,
    configure,
    GetStages,
} from '../../../types/schemaTypes';
import './JobStageSummary.scss';
import {
    ADD_STAGES,
    EDIT_STAGES,
    END_STAGES,
    PAUSE_STAGES,
    RESUME_STAGES,
    START_STAGES,
    ADD_CONFIGURE,
    ADD_EDIT_JOB_LOGS,
    REVERT_STAGES,
} from '../../../graphql/client/mutations';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'
import AddStageModal from './AddStageModal/AddStageModal';
import EditStageModal from './EditStageModal/EditStageModal';
import EndStageSummaryModal from './StageSummaryModals/EndStageSummaryModal';
import PauseStageSummaryModal from './StageSummaryModals/PauseStageSummaryModal';
import ResumeStageSummaryModal from './StageSummaryModals/ResumeStageSummaryModal';
import ConfigureEmailRecipientsModal from './ConfigureEmailRecipientsModal/ConfigureEmailRecipientsModal';
import { Link, useParams } from 'react-router-dom';
import { Routes } from '../../../utils/Routes';
import StartStageSummaryModal from './StageSummaryModals/StartStageSummaryModal';
import RevertStagesModal from './StageSummaryModals/RevertStageModal';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';

const JobStageSummary = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isViewStageSummaryEnabled = authContext.userHasPermission(PermissionEnum.ViewStageSummary);
    const isAddStageEnabled = authContext.userHasPermission(PermissionEnum.AddStages);
    const isEditStagesEnabled = authContext.userHasPermission(PermissionEnum.EditStages);
    const isRevertStagesEnabled = authContext.userHasPermission(PermissionEnum.RevertStages);
    const isStartEndStageEnabled = authContext.userHasPermission(PermissionEnum.StartEndStage);
    const isPauseResumeStageEnabled = authContext.userHasPermission(PermissionEnum.PauseResumeStage);
    const isViewStageSheetEnabled = authContext.userHasPermission(PermissionEnum.ViewStageSheet);
    const isViewStageHistoryEnabled = authContext.userHasPermission(PermissionEnum.ViewStageHistory);
    const isConfigureRecipientsEnabled = authContext.userHasPermission(PermissionEnum.ConfigureRecipients);
    const [state, dispatch] = useStoreContext();

    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + tabTitle;
    const abortController = new AbortController();
    let jobName: string | null = '';
    document.title = jobName;

    const [activeStageWellheadFilter, setActiveStageWellheadFilter] = useState('ALL');
    const [finishedStageWellheadFilter, setFinishedStageWellheadFilter] = useState('ALL');

    const [activeStagePageNum, setActiveStagePageNum] = useState(0);
    const [finishedStagePageNum, setFinishedStagePageNum] = useState(0);

    const [showAddStageModal, setShowAddStageModal] = useState(false);
    const [isInProcessJobStatus, setIsInProcessJobStatus] = useState(false);
    const [showAddConfigureRecipientsModal, setShowAddConfigureRecipientsModal] = useState(false);
    const [showEditStageModal, setShowEditStageModal] = useState(false);
    const [stageGroupId, setStageGroupId] = useState<number>(0);
    const [showStartStageModal, setShowStartStageModal] = useState(false);
    const [showEndStageModal, setShowEndStageModal] = useState(false);
    const [showPauseStageModal, setShowPauseStageModal] = useState(false);
    const [showResumeStageModal, setShowResumeStageModal] = useState(false);
    const [showRevertModal, setShowRevertModal] = useState(false);
    const [stageIdstoRevert, setStageIdstoRevert] = useState<number[]>([]);
    const [stageModalError, setStageModalError] = useState('');
    const [stageMsgNumbers, setStageMsgNumbers] = useState('');
    const [stageNumbers, setStageNumbers] = useState('');
    const [stageStatusData, setStageStatusData] = useState<any>();
    const [isBellyDump, setIsBellyDump] = useState(false);
    const { jobId } = useParams()
    const jobIdVal: any = jobId

    const toasterOptions = { duration: 2500 };
    const toastMessages = {
        addStage: `Stages added sucessfully`,
        editStage: `Stages edited sucessfully`,
        startStage: `Stages started sucessfully`,
        endStage: `Stages ended sucessfully`,
        pauseStage: `Stages paused sucessfully`,
        resumeStage: `Stages resumed sucessfully`,
        revertStage: `Stages reverted sucessfully`,
        AddConfigureRecipients: `Recipients saved successfully`,
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };
        Comp.displayName = 'toast';
        return Comp;
    };
    const [wellheadStageList, setWellheadStageList] = useState<any[]>([]);
    const [getStageId, { loading: detailsLoading, error: detailsError, data: details }] = useLazyQuery<GetWellheadsByStageGroupId>(
        GET_WELL_HEADS_BY_STAGE_GROUP_ID,
        { fetchPolicy: 'network-only' },
    );

    useEffect(() => {
        if (detailsLoading || !details?.getWellheadsByStageGroupId) return;
        setWellheadStageList(
            details.getWellheadsByStageGroupId.filter((r): r is NonNullable<typeof r> => r != null).map(record => ({
                stageId: record.jobStageId,
                status: record.status,
                wellHead: record.wellhead,
            })),
        );
    }, [details, detailsLoading]);

    const { loading: stageSummaryLoading, error: stageSummaryError, data: stageSummaryData } = useQuery<GetStageSummary>(
        GET_STAGE_SUMMARY,
        {
            variables: {
                jobId: parseInt(jobIdVal),
            },
            fetchPolicy: 'network-only',
        },
    );

    const { loading: activeStagesLoading, error: activeStagesError, data: activeStagesData, previousData: previousActiveData } = useQuery<GetStageDetails>(
        GET_STAGE_DETAILS,
        {
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    isCompleted: false,
                    pageNum: activeStagePageNum,
                    wellHead: encodeURIComponent(activeStageWellheadFilter),
                },
            },
            fetchPolicy: 'network-only',
        },
    );

    const { loading: finishedStagesLoading, error: finishedStagesError, data: finishedStagesData, previousData: previousFinishedData } = useQuery<GetStageDetails>(
        GET_STAGE_DETAILS,
        {
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    isCompleted: true,
                    pageNum: finishedStagePageNum,
                    wellHead: encodeURIComponent(finishedStageWellheadFilter),
                },
            },
            fetchPolicy: 'network-only',
        },
    );

    const { loading: wellheadsLoading, error: wellheadsError, data: wellheadsData } = useQuery<GetWellheadsByJobId>(GET_WELL_HEADS_BY_JOB_ID, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
    });
    // setIsInProcessJobStatus(true);

    const { loading: jobLogsMetaDataLoading, error: jobLogsMetaDataError, data: jobLogsMetaData } = useQuery<
        GetJobLogMetaData
    >(GET_JOB_LOG_META_DATA, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
    });

    const { loading: stagesLoading, error: stagesError, data: stagesData } = useQuery<GetStages>(GET_STAGES, {
        variables: {
            input: {
                jobId: parseInt(jobIdVal),
                proppantId: 0,
            },
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (activeStagesData && activeStagesData.getStageDetails) {
            if(activeStagesData.getStageDetails.isBellyDump != null){
                setIsBellyDump(activeStagesData.getStageDetails.isBellyDump);
            }
            if (activeStagesData.getStageDetails.jobStatus === 'InProgress') {
                setIsInProcessJobStatus(true);
            }
        }
        //   }, [activeStagesData.getStageDetails]);
    }, [activeStagesData]);

    const handleOnCloseModal = (modalType: string) => {
        setStageModalError('');
        modalType === 'addStage' && setShowAddStageModal(false);
        modalType === 'AddConfigureRecipients' && setShowAddConfigureRecipientsModal(false);
        modalType === 'editStage' && setShowEditStageModal(false);
        modalType === 'startStage' && setShowStartStageModal(false);
        modalType === 'endStage' && setShowEndStageModal(false);
        modalType === 'pauseStage' && setShowPauseStageModal(false);
        modalType === 'resumeStage' && setShowResumeStageModal(false);
        modalType === 'revertStage' && setShowRevertModal(false);
        modalType !== 'addStage' && setStageGroupId(0);
    };

    const handleOnComplete = (modalType: string) => {
        handleOnCloseModal(modalType);
        toast.success(toastMessages[modalType], toastOpt);

    };

    const [addStages, { loading: mutationLoading, error: mutationError }] = useMutation<AddStages>(ADD_STAGES, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => handleOnComplete('addStage'),
        refetchQueries: [
            {
                query: GET_STAGE_SUMMARY,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: false,
                        pageNum: activeStagePageNum,
                        wellHead: encodeURIComponent(activeStageWellheadFilter),
                    },
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: true,
                        pageNum: finishedStagePageNum,
                        wellHead: encodeURIComponent(finishedStageWellheadFilter),
                    },
                },
            },
        ],
    });

    const [revertStages, { loading: revertStagesLoading, error: revertStagesError }] = useMutation<AddStages>(
        REVERT_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('revertStage'),
            refetchQueries: [
                {
                    query: GET_STAGE_SUMMARY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: false,
                            pageNum: activeStagePageNum,
                            wellHead: encodeURIComponent(activeStageWellheadFilter),
                        },
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: true,
                            pageNum: finishedStagePageNum,
                            wellHead: encodeURIComponent(finishedStageWellheadFilter),
                        },
                    },
                },
            ],
        },
    );

    const [editStages, { loading: editStagesLoading, error: editStagesError }] = useMutation<AddStages>(EDIT_STAGES, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => handleOnComplete('editStage'),
        refetchQueries: [
            {
                query: GET_STAGE_SUMMARY,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: false,
                        pageNum: activeStagePageNum,
                        wellHead: encodeURIComponent(activeStageWellheadFilter),
                    },
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: true,
                        pageNum: finishedStagePageNum,
                        wellHead: encodeURIComponent(finishedStageWellheadFilter),
                    },
                },
            },
        ],
    });

    const [startStages, { loading: startStagesLoading, error: startStagesError }] = useMutation<AddStages>(
        START_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                    const errorMsg = serverErrorWithComa.split('|');
                    setStageModalError(errorMsg.join(','));
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('startStage'),
            refetchQueries: [
                {
                    query: GET_STAGE_SUMMARY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: false,
                            pageNum: activeStagePageNum,
                            wellHead: encodeURIComponent(activeStageWellheadFilter),
                        },
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: true,
                            pageNum: finishedStagePageNum,
                            wellHead: encodeURIComponent(finishedStageWellheadFilter),
                        },
                    },
                },
            ],
        },
    );

    const [endStages, { loading: endStagesLoading, error: endStagesError }] = useMutation<AddStages>(END_STAGES, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => handleOnComplete('endStage'),
        refetchQueries: [
            {
                query: GET_STAGE_SUMMARY,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: false,
                        pageNum: activeStagePageNum,
                        wellHead: encodeURIComponent(activeStageWellheadFilter),
                    },
                },
            },
            {
                query: GET_STAGE_DETAILS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        isCompleted: true,
                        pageNum: finishedStagePageNum,
                        wellHead: encodeURIComponent(finishedStageWellheadFilter),
                    },
                },
            },
        ],
    });

    const [addEditJobLog, { loading: addEditJobLogLoading }] = useMutation(ADD_EDIT_JOB_LOGS, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
    });

    const [pauseStages, { loading: pauseStagesLoading, error: pauseStagesError }] = useMutation<AddStages>(
        PAUSE_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('pauseStage'),
            refetchQueries: [
                {
                    query: GET_STAGE_SUMMARY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: false,
                            pageNum: activeStagePageNum,
                            wellHead: encodeURIComponent(activeStageWellheadFilter),
                        },
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: true,
                            pageNum: finishedStagePageNum,
                            wellHead: encodeURIComponent(finishedStageWellheadFilter),
                        },
                    },
                },
            ],
        },
    );

    const [resumeStages, { loading: resumeStagesLoading, error: resumeStagesError }] = useMutation<AddStages>(
        RESUME_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('resumeStage'),
            refetchQueries: [
                {
                    query: GET_STAGE_SUMMARY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: false,
                            pageNum: activeStagePageNum,
                            wellHead: encodeURIComponent(activeStageWellheadFilter),
                        },
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: true,
                            pageNum: finishedStagePageNum,
                            wellHead: encodeURIComponent(finishedStageWellheadFilter),
                        },
                    },
                },
            ],
        },
    );

    const [saveConfiguration, { loading: pauseConfigureLoading, error: startConfigureError }] = useMutation<configure>(
        ADD_CONFIGURE,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('AddConfigureRecipients'),
            refetchQueries: [
                {
                    query: GET_STAGE_SUMMARY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: false,
                            pageNum: activeStagePageNum,
                            wellHead: encodeURIComponent(activeStageWellheadFilter),
                        },
                    },
                },
                {
                    query: GET_STAGE_DETAILS,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            isCompleted: true,
                            pageNum: finishedStagePageNum,
                            wellHead: encodeURIComponent(finishedStageWellheadFilter),
                        },
                    },
                },
            ],
        },
    );

    const handleOnAddConfiguration = async inputs => {
        inputs.JobId = parseInt(jobIdVal);

        const variables = {
            input: inputs,
        };
        await saveConfiguration({ variables });
    };

    const handleOnShowAddStageModal = () => {
        setShowAddStageModal(true);
    };

    const handleOnAddStages = async (fracType: string, stageDetails: StageDetailsForAddStages[]) => {
        await addStages({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    fracType: fracType,
                    stageDetails: stageDetails,
                },
            },
        });
    };

    const handleOnEditStages = async (fracType: string, stageDetails: StageDetailsForEditStages[]) => {
        await editStages({
            variables: {
                input: {
                    stageGroupId: stageGroupId,
                    jobId: parseInt(jobIdVal),
                    fracType: fracType,
                    stageDetails: stageDetails,
                },
            },
        });
    };

    let stageSummary: StageSummary[] = [];
    if (stageSummaryData?.getStageSummary) {
        stageSummary = (stageSummaryData.getStageSummary ?? []).filter((s): s is StageSummary => s != null);
    }

    let isActiveStagePagingRequired = false;
    let isLastActiveStageItem = false;
    let activeStages: StageDetails[] = [];
    if (!activeStagesData && previousActiveData?.getStageDetails) {
        const pd = previousActiveData.getStageDetails;
        isActiveStagePagingRequired = pd.isPagingRequired ?? false;
        isLastActiveStageItem = pd.isLastItem ?? false;
        activeStages = (pd.stageDetails ?? []).filter((s): s is StageDetails => s != null);
    } else if (activeStagesData?.getStageDetails) {
        const ad = activeStagesData.getStageDetails;
        isActiveStagePagingRequired = ad.isPagingRequired ?? false;
        isLastActiveStageItem = ad.isLastItem ?? false;
        activeStages = (ad.stageDetails ?? []).filter((s): s is StageDetails => s != null);
    }

    let isFinishedStagePagingRequired = false;
    let isLastFinishedStageItem = false;
    let finishedStages: StageDetails[] = [];
    if (!finishedStagesData && previousFinishedData?.getStageDetails) {
        const pd = previousFinishedData.getStageDetails;
        isFinishedStagePagingRequired = pd.isPagingRequired ?? false;
        isLastFinishedStageItem = pd.isLastItem ?? false;
        finishedStages = (pd.stageDetails ?? []).filter((s): s is StageDetails => s != null);
    } else if (finishedStagesData?.getStageDetails) {
        const fd = finishedStagesData.getStageDetails;
        isFinishedStagePagingRequired = fd.isPagingRequired ?? false;
        isLastFinishedStageItem = fd.isLastItem ?? false;
        finishedStages = (fd.stageDetails ?? []).filter((s): s is StageDetails => s != null);
    }

    let wellheads: Wellheads[] = [];
    if (wellheadsData?.getWellheadsByJobId) {
        wellheads = (wellheadsData.getWellheadsByJobId ?? []).filter((w): w is Wellheads => w != null);
    }

    const jobLogsTypesData: JobLogTypesType[] = [];
    const jobLogsIssuesData: JobLogIssueType[] = [];
    const jobLogsRootCausesData: JobLogRootCauseType[] = [];
    const jobLogsLocationLofaData: JobLogLocationLofaType[] = [];
    if (jobLogsMetaData && jobLogsMetaData.getJobLogMetaData) {
        if (jobLogsMetaData.getJobLogMetaData.types)
            jobLogsMetaData.getJobLogMetaData.types.map(jobLogType => {
                if (jobLogType) jobLogsTypesData.push(jobLogType);
            });
        if (jobLogsMetaData.getJobLogMetaData.issues)
            jobLogsMetaData.getJobLogMetaData.issues.map(jobLogIssue => {
                if (jobLogIssue) jobLogsIssuesData.push(jobLogIssue);
            });
        if (jobLogsMetaData.getJobLogMetaData.rootcauses)
            jobLogsMetaData.getJobLogMetaData.rootcauses.map(jobLogRootCauses => {
                if (jobLogRootCauses) jobLogsRootCausesData.push(jobLogRootCauses);
            });
        if (jobLogsMetaData.getJobLogMetaData.locationLOFAs)
            jobLogsMetaData.getJobLogMetaData.locationLOFAs.map(jobLogLocationLofa => {
                if (jobLogLocationLofa) jobLogsLocationLofaData.push(jobLogLocationLofa);
            });
    }

    const stageData: StageNumberType[] = [];
    if (stagesData && stagesData.getStages) {
        stagesData.getStages.map(stage => {
            if (stage) stageData.push(stage);
        });
    }

    const handleOnStartStages = async (stageNumbers, jobId) => {
        const jobStageIds: number[] = [];
        activeStages.map(activeStage => {
            if (activeStage.stageGroupId === stageGroupId && activeStage.status === 'Preparing')
                activeStage.jobStageId && jobStageIds.push(activeStage.jobStageId);
        });
        await startStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                    jobId: parseInt(jobId),
                    fromStageSheet: false,
                },
            },
        });
    };

    const handleOnEndStages = async (jobStageIds: number[], comments) => {
        await endStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                    comments: comments,
                    fromStageSheet: false,
                },
            },
        });
    };

    const handleOnPauseStages = async (
        jobStageIds,
        jobLogId,
        jobLogTypeId,
        jobLogIssueId,
        startDate,
        endDate,
        estimatedDowntime,
        loadId,
        notes,
        locationLofa,
        amount,
        rootCauseId,
        correctiveAction,
    ) => {
        const result = await pauseStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                },
            },
        });

        if (result && result['data'] && result['data']['pauseStages']['errors'].length === 0) {
            jobStageIds.map(async jobStageId => {
                await addEditJobLog({
                    variables: {
                        input: {
                            jobLogId: jobLogId,
                            jobLogIssueId: jobLogIssueId,
                            jobLogTypeId: jobLogTypeId,
                            jobId: parseInt(jobIdVal),
                            startDate: startDate,
                            endDate: endDate,
                            estimatedDowntime: estimatedDowntime,
                            jobStageId: jobStageId,
                            loadId: loadId,
                            notes: notes,
                            locationLofa: locationLofa,
                            amount: amount,
                            rootCauseId: rootCauseId,
                            correctiveAction: correctiveAction,
                        },
                    },
                });
            });
        }
    };

    const handleOnResumeStages = async jobStageIds => {
        const result = await resumeStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                    jobId: parseInt(jobIdVal),
                },
            },
        });
    };

    const handleOnRevertStages = async jobStageIds => {
        await revertStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                },
            },
        });
    };

    if (activeStagesData && activeStagesData.getStageDetails) {
        jobName = activeStagesData.getStageDetails.wellName ?? '';
        document.title = jobName ?? '';
    }

    const structureBarChart = fillColor => {
        return function structuringBarChart(props) {
            const { fill, x, y, value, width, height } = props;
            const barValue = value[1] - value[0];
            if (barValue <= 0)
                return (
                    <g>
                        <rect x={x} y={y} width={0} height={0} stroke="none" fill={fillColor} />
                    </g>
                );

            return (
                <g>
                    <rect x={x} y={y} width={width} height={(height * 75) / 100} stroke="none" fill={fillColor} />
                    <text
                        x={x + width / 2}
                        y={y + (height * 75) / 100 / 2}
                        fill={'#000'}
                        fontSize={12}
                        textAnchor="middle"
                        alignmentBaseline="central"
                    >
                        {value[1] - value[0]}
                    </text>
                </g>
            );
        };
    };

    const barChartColors = {
        completed: '#4171ca',
        preparing: '#ffc608',
        running: '#00FF00',
        paused: '#ee7420',
        remaining: '#a9a9a9',
    };

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            return (
                <div className="StageSummary-Graph-Tooltip-Container" style={{ backgroundColor: payload[0].fill }}>
                    <p className="StageSummary-Graph-Tooltip-Data">wellhead : {payload[0].payload.wellhead}</p>
                    <p className="StageSummary-Graph-Tooltip-Data">
                        {payload[0].dataKey} : {payload[0].value}
                    </p>
                </div>
            );
        }

        return null;
    };

    const groupedActiveStages = {};
    const groupedActiveStagesStageSheets = {};
    const groupedActiveStagesButtons = {};
    for (const activeStage of activeStages) {
        if (activeStage.stageGroupId) {
            if (groupedActiveStages[activeStage.stageGroupId]) {
                groupedActiveStages[activeStage.stageGroupId].push(activeStage);

                if (
                    activeStage.stageSheetId &&
                    Object.keys(groupedActiveStagesStageSheets[activeStage.stageGroupId]).includes(
                        activeStage.stageSheetId.toString(),
                    )
                ) {
                    groupedActiveStagesStageSheets[activeStage.stageGroupId][activeStage.stageSheetId]['count'] += 1;
                    if (activeStage.status !== 'Completed')
                        groupedActiveStagesStageSheets[activeStage.stageGroupId][activeStage.stageSheetId][
                            'isCompleted'
                        ] = false;
                } else {
                    groupedActiveStagesStageSheets[activeStage.stageGroupId][activeStage.stageSheetId] = {
                        firstElement: activeStage.jobStageId,
                        isCompleted: activeStage.status === 'Completed' ? true : false,
                        count: 1,
                    };
                }

                if (
                    activeStage.status === 'Preparing' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Start')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Start');
                }
                if (
                    activeStage.status === 'Running' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('End')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('End');
                }
                if (
                    activeStage.status === 'Running' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Pause')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Pause');
                }
                if (
                    activeStage.status === 'Paused' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Resume')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Resume');
                }
                if (
                    activeStage.status === 'Paused' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('End')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('End');
                }
            } else {
                groupedActiveStages[activeStage.stageGroupId] = [];
                groupedActiveStages[activeStage.stageGroupId].push(activeStage);

                groupedActiveStagesStageSheets[activeStage.stageGroupId] = {};
                if (activeStage.stageSheetId) {
                    groupedActiveStagesStageSheets[activeStage.stageGroupId][activeStage.stageSheetId] = {
                        firstElement: activeStage.jobStageId,
                        isCompleted: activeStage.status === 'Completed' ? true : false,
                        count: 1,
                    };
                }

                groupedActiveStagesButtons[activeStage.stageGroupId] = [];
                if (
                    activeStage.status === 'Preparing' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Start')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Start');
                }
                if (
                    activeStage.status === 'Running' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('End')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('End');
                }
                if (
                    activeStage.status === 'Running' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Pause')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Pause');
                }
                if (
                    activeStage.status === 'Paused' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('Resume')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('Resume');
                }
                if (
                    activeStage.status === 'Paused' &&
                    !groupedActiveStagesButtons[activeStage.stageGroupId].includes('End')
                ) {
                    groupedActiveStagesButtons[activeStage.stageGroupId].push('End');
                }
            }
        }
    }

    const groupedFinishedStages = {};
    const groupedFinishedStagesStageSheets = {};
    for (const finishedStage of finishedStages) {
        if (finishedStage.stageGroupId) {
            if (groupedFinishedStages[finishedStage.stageGroupId]) {
                groupedFinishedStages[finishedStage.stageGroupId].push(finishedStage);

                if (
                    finishedStage.stageSheetId &&
                    Object.keys(groupedFinishedStagesStageSheets[finishedStage.stageGroupId]).includes(
                        finishedStage.stageSheetId.toString(),
                    )
                ) {
                    groupedFinishedStagesStageSheets[finishedStage.stageGroupId][finishedStage.stageSheetId][
                        'count'
                    ] += 1;
                    groupedFinishedStagesStageSheets[finishedStage.stageGroupId][finishedStage.stageSheetId][
                        'jobStageIds'
                    ].push(finishedStage.jobStageId);
                } else {
                    groupedFinishedStagesStageSheets[finishedStage.stageGroupId][finishedStage.stageSheetId] = {
                        firstElement: finishedStage.jobStageId,
                        count: 1,
                        jobStageIds: [finishedStage.jobStageId],
                    };
                }
            } else {
                groupedFinishedStages[finishedStage.stageGroupId] = [];
                groupedFinishedStages[finishedStage.stageGroupId].push(finishedStage);

                groupedFinishedStagesStageSheets[finishedStage.stageGroupId] = {};
                if (finishedStage.stageSheetId) {
                    groupedFinishedStagesStageSheets[finishedStage.stageGroupId][finishedStage.stageSheetId] = {
                        firstElement: finishedStage.jobStageId,
                        count: 1,
                        jobStageIds: [finishedStage.jobStageId],
                    };
                }
            }
        }
    }

    if (!isViewStageSummaryEnabled) {
        return (
            <div className="StageSummary-Container">
                <ToastContainer />
                <div className="StageSummary-Header-Container">
                    <div className="StageSummary-Header">Stage Summary: {jobName}</div>
                    <div style={{ width: 250 }}></div>

                    <JobMenuItems jobId={jobId ?? '0'} menu='stageSummary'/>
                </div>

                <div className="NoResult-Container StageSummary-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            </div>
        );
    }

    return (
        <div className="StageSummary-Container">
            <ToastContainer />
            <div className="StageSummary-Header-Container">
                <div className="StageSummary-Header">Stage Summary: {jobName}</div>
                <div style={{ width: 250 }}></div>

                <JobMenuItems jobId={jobId ?? '0'} menu='stageSummary'/>
            </div>

            <div className="StageSummary-Graph-Container">
                {stageSummaryLoading ? (
                    <div className="StageSummary-Loading ">
                        <Loading />
                    </div>
                ) : stageSummaryError ? (
                    <div className="StageSummary-Graph-Error">
                        <Error error={stageSummaryError} />
                    </div>
                ) : stageSummary.length === 0 ? (
                    <div className="StageSummary-NoResult-Container StageSummary-Graph-NoResult-Container">
                        <div className="NoResult-Second-Title-Primary">No Stage Summary Found</div>
                    </div>
                ) : (
                    <ResponsiveContainer width="95%" height={stageSummary.length < 3 ? 200 : 400}>
                        <BarChart
                            data={stageSummary}
                            layout="vertical"
                            margin={{
                                top: 20,
                                bottom: 15,
                            }}
                        >
                            <XAxis type="number" tick={false} />
                            <YAxis
                                type="category"
                                dataKey="wellhead"
                                width={135}
                                style={{ textAnchor: 'end', fontSize: '12px', fill: 'black' }}
                            />
                            <Bar
                                dataKey="completed"
                                stackId="a"
                                fill={barChartColors.completed}
                                height={50}
                                shape={structureBarChart(barChartColors.completed)}
                            />
                            <Bar
                                dataKey="preparing"
                                stackId="a"
                                fill={barChartColors.preparing}
                                shape={structureBarChart(barChartColors.preparing)}
                            />
                            <Bar
                                dataKey="running"
                                stackId="a"
                                fill={barChartColors.running}
                                shape={structureBarChart(barChartColors.running)}
                            />
                            <Bar
                                dataKey="paused"
                                stackId="a"
                                fill={barChartColors.paused}
                                shape={structureBarChart(barChartColors.paused)}
                            />
                            <Bar
                                dataKey="remaining"
                                stackId="a"
                                fill={barChartColors.remaining}
                                shape={structureBarChart(barChartColors.remaining)}
                            />
                            <Legend
                                formatter={(value, entry, index) => (
                                    <span className="StageSummary-Graph-Legend">{value}</span>
                                )}
                            />
                            <Tooltip shared={false} content={<CustomTooltip />} />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </div>

            <div className="StageSummary-Active-Stages">
                <div className="StageSummary-Stages-Header">
                    <div className="StageSummary-Stages-Header-Text">Active Stages</div>
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="outline-dark"
                            id="dropdown-basic"
                            className="StageSummary-Wellhead-Filter"
                        >
                            <span>
                                {activeStageWellheadFilter !== 'ALL' ? activeStageWellheadFilter : 'Select Wellhead'}
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     setActiveStagePageNum(0);
                                //     setActiveStageWellheadFilter('ALL');
                                // }}
                                onClick={() => {
                                    setActiveStagePageNum(0);
                                    setActiveStageWellheadFilter('ALL');
                                }}

                            >
                                All Wellheads
                            </Dropdown.Item>
                            {wellheads.map((wellhead, index) => (
                                <Dropdown.Item
                                    key={index}
                                    // onSelect={() => {
                                    //     setActiveStagePageNum(0);
                                    //     wellhead.wellHead && setActiveStageWellheadFilter(wellhead.wellHead);
                                    // }}
                                    onClick={() => {
                                        setActiveStagePageNum(0);
                                        wellhead.wellHead && setActiveStageWellheadFilter(wellhead.wellHead);
                                    }}
                                >
                                    {wellhead.wellHead}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {activeStagesLoading && (
                    <div className={activeStages.length === 0 ? 'StageSummary-Loading' : 'StageSummary-Loading-Center'}>
                        <Loading />
                    </div>
                )}
                {activeStagesError && <Error error={activeStagesError} />}
                {!activeStagesLoading && activeStages.length === 0 && (
                    <div className="StageSummary-NoResult-Container">
                        <div className="NoResult-Second-Title-Primary">No Active Stages Found</div>
                    </div>
                )}
                {activeStages.length !== 0 && (
                    <div className="tableContainer">
                        <Table striped bordered className="tabletest  custom-stage-summary">
                            <thead>
                                <tr>
                                    <th>Wellhead</th>
                                    <th>Stage #</th>
                                    <th>Overall Stage #</th>
                                    <th>Start Date</th>
                                    <th>Status</th>
                                    <th>Frac Type</th>
                                    <th>Edit</th>
                                    <th>Stage Sheet</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: teams">
                                {Object.keys(groupedActiveStages)
                                    .reverse()
                                    .map(groupId => {
                                        return groupedActiveStages[groupId].map((activeStage, index) => {
                                            return (
                                                <tr key={index} className='custom'>
                                                    <td>{activeStage.wellhead}</td>
                                                    <td>{activeStage.stage}</td>
                                                    <td>{activeStage.overallStage}</td>
                                                    <td>{activeStage.startDate}</td>
                                                    <td>{activeStage.status}</td>
                                                    {index === 0 && (
                                                        <td
                                                            rowSpan={groupedActiveStages[groupId].length}
                                                            className="StageSummary-Fractype-Container"
                                                        >
                                                            {activeStage.fracType}
                                                        </td>
                                                    )}
                                                    {index === 0 && (
                                                        <td
                                                            rowSpan={groupedActiveStages[groupId].length}
                                                            className="StageSummary-Stages-Button-Container"
                                                        >
                                                            {isEditStagesEnabled && isInProcessJobStatus && (
                                                                <div
                                                                    className="StageSummary-Stages-Button grey-column"
                                                                    onClick={() => {
                                                                        setShowEditStageModal(true);
                                                                        setStageGroupId(activeStage.stageGroupId ?? 0);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </div>
                                                            )}
                                                        </td>
                                                    )}
                                                    {groupedActiveStagesStageSheets[groupId][activeStage.stageSheetId][
                                                        'firstElement'
                                                    ] === activeStage.jobStageId && (
                                                            <td
                                                                rowSpan={
                                                                    groupedActiveStagesStageSheets[groupId][
                                                                    activeStage.stageSheetId
                                                                    ]['count']
                                                                }
                                                                className="StageSummary-Stages-Button-Container"
                                                            >
                                                                {isViewStageSheetEnabled && (
                                                                    <div className="StageSummary-Stages-Button grey-column">
                                                                        {groupedActiveStagesStageSheets[groupId][
                                                                            activeStage.stageSheetId
                                                                        ]['isCompleted'] ? (
                                                                            <>
                                                                            {isBellyDump ?
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET_BELLY_DUMP_RO.route}${activeStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage History
                                                                            </Link>) :
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET_RO.route}${activeStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage History
                                                                            </Link>)
                                                                            }
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                            {isBellyDump ?
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET_BELLY_DUMP.route}${activeStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage Sheet
                                                                            </Link>) :
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET.route}${activeStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage Sheet
                                                                            </Link>)
                                                                            }
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </td>
                                                        )}
                                                    {index === 0 && (
                                                        <td
                                                            rowSpan={groupedActiveStages[groupId].length}
                                                            className="StageSummary-Stages-Button-Container"
                                                        >
                                                            <div className="StageSummary-Stages-Buttons grey-column">
                                                                {isStartEndStageEnabled &&
                                                                    isInProcessJobStatus &&
                                                                    groupedActiveStagesButtons[groupId].includes(
                                                                        'Start',
                                                                    ) && (
                                                                        <div
                                                                            className="StageSummary-Stages-Button StageSummary-Stages-Button-Spacer"
                                                                            onClick={() => {
                                                                                setStageGroupId(
                                                                                    activeStage.stageGroupId ?? 0,
                                                                                );

                                                                                const stageNumbers = groupedActiveStages[
                                                                                    groupId
                                                                                ]
                                                                                    .filter(
                                                                                        s =>
                                                                                            s.stageGroupId ===
                                                                                            activeStage.stageGroupId &&
                                                                                            s.status === 'Preparing',
                                                                                    )
                                                                                    .map(ele => ele.overallStage);

                                                                                setStageMsgNumbers(
                                                                                    stageNumbers.join(','),
                                                                                );
                                                                                setShowStartStageModal(true);
                                                                            }}
                                                                        >
                                                                            Start
                                                                        </div>
                                                                    )}
                                                                {isStartEndStageEnabled &&
                                                                    isInProcessJobStatus &&
                                                                    groupedActiveStagesButtons[groupId].includes(
                                                                        'End',
                                                                    ) && (
                                                                        <div
                                                                            className="StageSummary-Stages-Button StageSummary-Stages-Button-Spacer"
                                                                            onClick={() => {
                                                                                setStageGroupId(
                                                                                    activeStage.stageGroupId ?? 0,
                                                                                );
                                                                                setShowEndStageModal(true);
                                                                            }}
                                                                        >
                                                                            End
                                                                        </div>
                                                                    )}
                                                                {isPauseResumeStageEnabled &&
                                                                    isInProcessJobStatus &&
                                                                    groupedActiveStagesButtons[groupId].includes(
                                                                        'Pause',
                                                                    ) && (
                                                                        <div
                                                                            className="StageSummary-Stages-Button StageSummary-Stages-Button-Spacer"
                                                                            onClick={() => {
                                                                                setShowPauseStageModal(true);
                                                                                setStageGroupId(
                                                                                    activeStage.stageGroupId ?? 0,
                                                                                );
                                                                            }}
                                                                        >
                                                                            Pause
                                                                        </div>
                                                                    )}
                                                                {isPauseResumeStageEnabled &&
                                                                    isInProcessJobStatus &&
                                                                    groupedActiveStagesButtons[groupId].includes(
                                                                        'Resume',
                                                                    ) && (
                                                                        <div
                                                                            className="StageSummary-Stages-Button"
                                                                            onClick={() => {
                                                                                setShowResumeStageModal(true);
                                                                                setStageGroupId(
                                                                                    activeStage.stageGroupId ?? 0,
                                                                                );
                                                                            }}
                                                                        >
                                                                            Resume
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        });
                                    })}
                            </tbody>
                        </Table>
                    </div>
                )}

                <div className="StageSummary-Stages-Footer">
                    <div className="StageSummary-Stages-Config-AddStage">
                        {isAddStageEnabled && isInProcessJobStatus && (
                            <CustomButton title={'Add Stages'} onClick={handleOnShowAddStageModal} />
                        )}
                        {isConfigureRecipientsEnabled && (
                            <div className="StageSummary-Config-Button">
                                <CustomButton
                                    title={'Configure Recipients'}
                                    onClick={() => setShowAddConfigureRecipientsModal(true)}
                                />
                            </div>
                        )}
                    </div>

                    {isActiveStagePagingRequired && (
                        <div className="StageSummary-Stages-Prev-Next-Container">
                            <div
                                className={`StageSummary-Stages-Prev ${(activeStagesLoading ||
                                    activeStagePageNum === 0) &&
                                    'StageSummary-Stages-Prev-Next-Disabled'}`}
                                onClick={() =>
                                    !activeStagesLoading &&
                                    activeStagePageNum !== 0 &&
                                    setActiveStagePageNum(activeStagePageNum - 1)
                                }
                            >
                                <i className="material-icons">chevron_left</i>
                                Previous
                            </div>
                            <div
                                className={`StageSummary-Stages-Prev ${(activeStagesLoading || isLastActiveStageItem) &&
                                    'StageSummary-Stages-Prev-Next-Disabled'}`}
                                onClick={() =>
                                    !activeStagesLoading &&
                                    !isLastActiveStageItem &&
                                    setActiveStagePageNum(activeStagePageNum + 1)
                                }
                            >
                                Next
                                <i className="material-icons">chevron_right</i>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="StageSummary-Finished-Stages">
                <div className="StageSummary-Stages-Header">
                    <div className="StageSummary-Stages-Header-Text">Completed Stages</div>
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="outline-dark"
                            id="dropdown-basic"
                            className="StageSummary-Wellhead-Filter"
                        >
                            <span>
                                {finishedStageWellheadFilter !== 'ALL'
                                    ? finishedStageWellheadFilter
                                    : 'Select Wellhead'}
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     setFinishedStagePageNum(0);
                                //     setFinishedStageWellheadFilter('ALL');
                                // }}
                                onClick={() => {
                                    setFinishedStagePageNum(0);
                                    setFinishedStageWellheadFilter('ALL');
                                }}
                            >
                                All Wellheads
                            </Dropdown.Item>
                            {wellheads.map((wellhead, index) => (
                                <Dropdown.Item
                                    key={index}
                                    // onSelect={() => {
                                    //     setFinishedStagePageNum(0);
                                    //     wellhead.wellHead && setFinishedStageWellheadFilter(wellhead.wellHead);
                                    // }}
                                    onClick={() => {
                                        setFinishedStagePageNum(0);
                                        wellhead.wellHead && setFinishedStageWellheadFilter(wellhead.wellHead);
                                    }}
                                >
                                    {wellhead.wellHead}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {finishedStagesLoading && (
                    <div
                        className={finishedStages.length === 0 ? 'StageSummary-Loading' : 'StageSummary-Loading-Center'}
                    >
                        <Loading />
                    </div>
                )}
                {finishedStagesError && <Error error={finishedStagesError} />}
                {!finishedStagesLoading && finishedStages.length === 0 && (
                    <div className="StageSummary-NoResult-Container">
                        <div className="NoResult-Second-Title-Primary">No Completed Stages Found</div>
                    </div>
                )}
                {finishedStages.length !== 0 && (
                    <div className="tableContainer">
                        <Table striped bordered className="tabletest custom-stage-summary">
                            <thead>
                                <tr>
                                    <th>Wellhead</th>
                                    <th>Stage #</th>
                                    <th>Overall Stage #</th>
                                    <th>Stage Start</th>
                                    <th>Stage End</th>
                                    <th>Notes</th>
                                    {isRevertStagesEnabled && <th>Revert</th>}
                                    <th>Frac Type</th>
                                    <th>Stage History</th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: teams">
                                {Object.keys(groupedFinishedStages)
                                    .reverse()
                                    .map(groupId => {
                                        return groupedFinishedStages[groupId].map((finishedStage, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{finishedStage.wellhead}</td>
                                                    <td>{finishedStage.stage}</td>
                                                    <td>{finishedStage.overallStage}</td>
                                                    <td>{finishedStage.startDate}</td>
                                                    <td>{finishedStage.endDate}</td>
                                                    {finishedStage.comments.length > 0 ? (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={
                                                                <div className="Notes-Tooltip">
                                                                    {finishedStage.comments}
                                                                </div>
                                                            }
                                                        >
                                                            <td className="StageSummary-Notes">
                                                                {finishedStage.comments}
                                                            </td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td className="StageSummary-Notes">{finishedStage.comments}</td>
                                                    )}
                                                    {isRevertStagesEnabled &&
                                                        groupedFinishedStagesStageSheets[groupId][
                                                        finishedStage.stageSheetId
                                                        ]['firstElement'] === finishedStage.jobStageId && (
                                                            <td
                                                                rowSpan={
                                                                    groupedFinishedStagesStageSheets[groupId][
                                                                    finishedStage.stageSheetId
                                                                    ]['count']
                                                                }
                                                                className="StageSummary-Stages-Button-Container"
                                                            >
                                                                <div
                                                                    className="StageSummary-Stages-Button"
                                                                    onClick={() => {
                                                                        setShowRevertModal(true);
                                                                        setStageIdstoRevert(
                                                                            groupedFinishedStagesStageSheets[groupId][
                                                                            finishedStage.stageSheetId
                                                                            ]['jobStageIds'],
                                                                        );
                                                                    }}
                                                                >
                                                                    Revert
                                                                </div>
                                                            </td>
                                                        )}
                                                    {index === 0 && (
                                                        <td
                                                            rowSpan={groupedFinishedStages[groupId].length}
                                                            className="StageSummary-Fractype-Container"
                                                        >
                                                            {finishedStage.fracType}
                                                        </td>
                                                    )}
                                                    {groupedFinishedStagesStageSheets[groupId][
                                                        finishedStage.stageSheetId
                                                    ]['firstElement'] === finishedStage.jobStageId && (
                                                            <td
                                                                rowSpan={
                                                                    groupedFinishedStagesStageSheets[groupId][
                                                                    finishedStage.stageSheetId
                                                                    ]['count']
                                                                }
                                                                className="StageSummary-Stages-Button-Container"
                                                            >
                                                                {isViewStageHistoryEnabled && (
                                                                    <div className="StageSummary-Stages-Button">
                                                                        <>
                                                                            {isBellyDump ?
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET_BELLY_DUMP_RO.route}${finishedStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage History
                                                                            </Link>) :
                                                                            (<Link
                                                                                to={{
                                                                                    pathname: `${Routes.STAGE_SHEET_RO.route}${finishedStage.stageSheetId}`,
                                                                                }}
                                                                                className="StageSummary-StageSheet-Link"
                                                                            >
                                                                                Stage History
                                                                            </Link>)
                                                                            }
                                                                            </>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        )}
                                                </tr>
                                            );
                                        });
                                    })}
                            </tbody>
                        </Table>
                    </div>
                )}

                <div className="StageSummary-FinishedStages-Footer">
                    {isFinishedStagePagingRequired && (
                        <div className="StageSummary-Stages-Prev-Next-Container">
                            <div
                                className={`StageSummary-Stages-Prev ${(finishedStagesLoading ||
                                    finishedStagePageNum === 0) &&
                                    'StageSummary-Stages-Prev-Next-Disabled'}`}
                                onClick={() =>
                                    !finishedStagesLoading &&
                                    finishedStagePageNum !== 0 &&
                                    setFinishedStagePageNum(finishedStagePageNum - 1)
                                }
                            >
                                <i className="material-icons">chevron_left</i>
                                Previous
                            </div>
                            <div
                                className={`StageSummary-Stages-Prev ${(finishedStagesLoading ||
                                    isLastFinishedStageItem) &&
                                    'StageSummary-Stages-Prev-Next-Disabled'}`}
                                onClick={() =>
                                    !finishedStagesLoading &&
                                    !isLastFinishedStageItem &&
                                    setFinishedStagePageNum(finishedStagePageNum + 1)
                                }
                            >
                                Next
                                <i className="material-icons">chevron_right</i>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showAddStageModal && (
                <AddStageModal
                    showAddStageModal={showAddStageModal}
                    wellheads={wellheads}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnAddStages}
                    mutationLoading={mutationLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                    JobId={parseInt(jobIdVal)}
                />
            )}

            {showEditStageModal && (
                <EditStageModal
                    showEditStageModal={showEditStageModal}
                    wellheads={wellheads}
                    stageGroupId={stageGroupId}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnEditStages}
                    mutationLoading={editStagesLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                    JobId={parseInt(jobIdVal)}
                />
            )}

            {showStartStageModal && stageGroupId !== 0 && (
                // <StartStageModal
                //     showStartStageModal={showStartStageModal}
                //     // stageGroupId={stageGroupId}
                //     stageNumbsers={stageNumbsers}
                //     JobId={parseInt(match.params.jobId)}
                //     handleOnClose={handleOnCloseModal}
                //     handleOnSave={handleOnStartStages}
                //     mutationLoading={startStagesLoading}
                //     mutationError={stageModalError}
                // />
                <StartStageSummaryModal
                    showStartStageModal={showStartStageModal}
                    stageNumbers={stageNumbers}
                    stageGroupId={stageGroupId}
                    stageMsgNumbers={stageMsgNumbers}
                    jobId={parseInt(jobIdVal)}
                    jobLogRootCauses={jobLogsRootCausesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnStartStages}
                    mutationLoading={startStagesLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                />
            )}

            {showEndStageModal && (
                <EndStageSummaryModal
                    showEndStageModal={showEndStageModal}
                    stageGroupId={stageGroupId}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnEndStages}
                    mutationLoading={endStagesLoading}
                    mutationError={stageModalError}
                />
            )}

            {showPauseStageModal && (
                <PauseStageSummaryModal
                    showPauseStageModal={showPauseStageModal}
                    stageGroupId={stageGroupId}
                    jobLogsTypesData={jobLogsTypesData}
                    jobLogIssues={jobLogsIssuesData}
                    jobLogRootCauses={jobLogsRootCausesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnPauseStages}
                    mutationLoading={pauseStagesLoading || addEditJobLogLoading}
                    mutationError={stageModalError}
                />
            )}

            {showResumeStageModal && (
                <ResumeStageSummaryModal
                    showResumeStageModal={showResumeStageModal}
                    stageGroupId={stageGroupId}
                    jobId={parseInt(jobIdVal)}
                    jobLogRootCauses={jobLogsRootCausesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnResumeStages}
                    mutationLoading={resumeStagesLoading || addEditJobLogLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                />
            )}

            {showRevertModal && (
                <RevertStagesModal
                    showRevertStageModal={showRevertModal}
                    jobStageIds={stageIdstoRevert}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnRevertStages}
                    modalError={stageModalError}
                    mutationLoading={revertStagesLoading}
                />
            )}

            {showAddConfigureRecipientsModal && (
                <ConfigureEmailRecipientsModal
                    showAddConfigureRecipientsModal={showAddConfigureRecipientsModal}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnAddConfiguration}
                    mutationLoading={pauseConfigureLoading}
                    mutationError={stageModalError}
                    JobId={parseInt(jobIdVal)}
                />
            )}
        </div>
    );
};

export default JobStageSummary;
